import type {
  KenmerkLookup,
  KenmerkSearchMatchWithHighlight,
} from '../../../../types';
import getMatchingHighlightSubstring from '~/components/page/Apps/Realworks/util/getMatchingHighlightSubstring';
import findKenmerkenByQuery from '../../../../util/findKenmerkenByQuery';

const buildKenmerkSearchMatches = (
  kenmerkLookup: KenmerkLookup,
  query: string,
): Array<KenmerkSearchMatchWithHighlight> =>
  findKenmerkenByQuery(kenmerkLookup, query).flatMap(match => {
    const highlightSubstring = getMatchingHighlightSubstring(
      match.kenmerk.description,
      query,
    );

    return highlightSubstring ? [{ ...match, highlightSubstring }] : [];
  });

export default buildKenmerkSearchMatches;
